module.exports = __webpack_public_path__ + "img/bronze.39e958e0.png";